import { render } from "./IFCFilesContainer.vue?vue&type=template&id=55c1a598&scoped=true"
import script from "./IFCFilesContainer.vue?vue&type=script&lang=js"
export * from "./IFCFilesContainer.vue?vue&type=script&lang=js"

import "./IFCFilesContainer.vue?vue&type=style&index=0&id=55c1a598&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c1a598"]])

export default __exports__